import React from "react"
import { Link } from "gatsby"

import Layout from '../../components/layout'
import Seo from '../../components/seo'

import '../css/article.css'
//import images
import img1 from '../../images/time-travel/timetravel_img1jpg.png'
import img2 from '../../images/time-travel/timetravel_img2jpg.png'
import img3 from '../../images/time-travel/timetravel_img3jpg.png'
import img4 from '../../images/time-travel/timetravel_img4jpg.png'
import img5 from '../../images/time-travel/timetravel_img5jpg.png'
import img6 from '../../images/time-travel/timetravel_img6jpg.png'
import img7 from '../../images/time-travel/timetravel_img7jpg.png'
import logo from '../../images/time-travel/timetravel_logo.jpg'
//import video
import Video from '../../videos/ghost.mp4'
import robot from '../../images/robot.png'
import bat from '../../images/bat.png'

const IndexPage = () => {
 
  return  (
<Layout>
    <Seo 
    title="Time travel mystery ,the truth-TIME TRAVEL|SKTUTS"
    description="Do you know in mid 1950s a lady was using mobile phone while walking on the set of a Charlie Chaplin movie.But how as mobiles where not invented at that time.Lets see"
    keywords="time travel,time traveller's wife,time travel movies,time travel books,time travel machine,time travel theory,time travel paradox,time travel anime,time travel to the past,time travel movies 2018,time travel series,time travel device,time travel definition,time travel equation,time travel einstein,time travel cartoon,time travel films,time travel ao3,time travel fiction,time travel app,time travel documentary,time travel facts,time travel backwards,time travel fanfiction,time travel drama,time travel formula,time travel meaning,time travel chinese drama,time travel clock,time travel car,time travel article,time travel flight,time travel airplane,time travel butterfly effect,time travel agency,time travel dream meaning,time travel comics,time travel effect,time travel asian drama,time travel concept,time travel essay,time travel comedy movies,time travel debugging,time travel company,time travel event,time travel movie in hindi,time travel in hindi,time travel book pdf,time travel aeroplane,time travel animated movies,time travel based tv series,time travel basics,time travel best movies,time travel boy,time travel captain marvel,time travel dance,time travel full movie,time travel according to einstein,time travel bollywood movies,time travel by adrian rumble,time travel chinese movies,time travel debugging redux,time travel debugging visual studio,time travel drama korean,time travel endgame,time travel english movies,time travel english series,time travel explain,time travel explained in endgame,time travel from india to australia,time travel full movie in hindi,time travel funny quotes"
    />
    <header>
    <h1 className="header-h1">The mystery of time travel revealed</h1>

    <div className="header-banner">
        <img src={logo} alt="time travel"/>
    </div>
   
    </header>
     
            <section className="content">
            <article>
            <h1>The mystery behind the time travel incidents debunked</h1>
                      <p>Many peoples have given various theories to prove that time travel really happened.There are many images on the internet which claims to prove the time travel incidents.Lets see each of them</p>
                      <ul>
                        <li>Let's take the first image .Have a look at it<br/>
                          <img src={img1} alt="The man with funky goggles and jeans in 1940s" />
                          This photo was taken in november 1940 in the South Fork Bridge Canada. Everything looks normal in the image until some people claimed that the guy in the red circle is a time traveller as his clothes are modern and also he is wearing goggles which according to some people was not available in that time and hence classified him as a time traveller.<br/>
                           This photo was taken at a time when the place was in a flood and was kept in an exhibition in 2004 in a museum.The exhibition was named as <big>"Their Past lives here" </big> and many of those photos in the exhibition were digitalised in 2010.After the digitalisation in 2010 this photo came in people's hand and everyone started claiming that he is time traveller.The main focus of this photo was his good looks, goggles,his t shirt and a camera in his hand.
                           Lets see the truth.
                           <br/>
                           The goggles he was wearing was common in those times. This was used by many celebrtities at those times.<br/>
                           <img src={img2} alt="time travel pic of a google in 1940" />
                          <br/>
                          While his tshirt is considered it is of Montreal maroons hockey team playing between 1924 and 1938 and he might be their big fan and might have purchased their t shirt.
                          <br/>
                          As far as his camera is concerned these types of camera were produced by kodak much before 1930 and was very much compact and he might have purchased them.
                          <br/>
                          Hence it is proved that he is not a time traveller and is person who follows fashion very much and is a normal person.<br/> <br/>
                          <br/>
                          <br/>
                        </li> 
                        <li>
                          Now let's come to the Mike Tyson 1995 boxing match.Have a look at the image bolow.<br/>
                          <img src={img3} alt="Mike Tyson 1995 boxing match" />
                          In this photo you can see a lady in the crowd is using a camera phone to shoot the boxing match but the first camera phone was launched in 2000.So how did the lady got the phone to use.Let's see
                          <br/>
                          The CASIO company at that time was building portable cameras with which you can record video and photos.It is the same camera.<br/>
                          <img src={img4} alt="Casio portable camera in 1990"  />
                          <br/>
                          This is the same device
                        </li>
                        <li>
                          Now lets see our third image <br/>
                          <img src={img5} alt="A lady talking in a phone in mid 1900" /><br/>
                          Meet this young lady talking in a phone in 1950s and a time traveller according to some people.At that time while talking in a phone she was going somewhere.Let's see
                          <br/>
                          The thing in her hands may be a purse or something like a glass cover with which she might be trying to cover her face as there were cameraman nearby her. 
                          <br/>
                          Also this cannot be a mobile phone as there were no towers at that time and hence no mobile signals so that she can talk to anyone.But some idiotic peoples may say she brought a tower and satellites with her when she came from future.
                        </li>
                        <li>
                          Here is the fourth image<br/>
                          <img src={img6} alt="lady talking in phone in charlie chaplin's movie" /><br/>
                          This photo was taken during a shooting of a Charlie Chaplin movie.In this photo a lady is again talking in phone but if you look closely then it might look like a manual hearing aid which was popular in those times.Also due to reasons mentioned in previous point it is not possible that she is talking in phone.
                        </li>
                        <li>
                          Let's have a glance at the fifth image <br/>
                          <img src={img7} alt="movie scene in 1948 with hero using gps" /><br/>
                          This is an image of a movie of 1948 where the image shows he was using a GPS while going on a cart.He was holding a mobile device.Let's find out
                          <br/>
                          But this is not a phone. If you closely look at the image it is a notepad and not a phone.Also consider the fact that this is a movie. Movie makers always fool peoples and why the hell are people believing in a movie. 
                        </li>
                        <li>
                            Our next clue is a video.Have a look at this youtube video<br/>
                            <div >
                            <video width="280" height="240" controls autoplay>
                                <source src={Video} type="video/mp4" />
                                Your browser does not support the video tag.
                                </video>
                        </div>
                                                    <br/>Here a man enters a shop mysteriously and as he enters the date and time on camera starts to fluctuate and as the man comes out it becomes normal.What do you think about it.Is this a real example of time lapse.Let's discover.
                            <br/>
                            If you investigate a little bit this video is a trailer of an augmented reality MMO based game created by delta game. The name of game is delta T and is based on theme of time travel.
                        </li>
                        
                      </ul>
                      Source for this data<br/>
                      <iframe title="video1" width="280" height="240" src="https://www.youtube.com/embed/5HJYzfOmSJg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            </article>
            <div className="other">
                <div className="content1">
                  <Link to="/isro-aditya-l1/aditya-l1-isro-mission-to-conquer-the-sun">
                     <h4>
                        ISRO's mission to conquer the sun    
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/area-51/the-mystery-of-area-51-revealed">
                     <h4>
                        The mystery of area 51 revealed
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/amazon.com/unique-products-available-on-amazon">
                     <h4>
                        Unique products available on amazon.in
                      <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/cicada-3301/the-unsolved-mystery-of-cicada-3301">
                     <h4>
                        The unsolved mystery of cicada 3301
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="create-a-blog/an-indepth-guide-on-how-to-make-a-blog">
                     <h4>
                        How to create a free blog
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/truecaller-truth/truecaller-business-model-and -truth-revealed">
                     <h4>
                         The truth of truecaller app
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/devil-sea/the-mystery-of-devil-sea">
                     <h4>
                        The unsolved mystery of devil sea
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/earn-money-online/ultimate-guide-to-earn-money-in-2019">
                     <h4>
                         Simple steps to earn money online
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/sun-facts/what-if-the-sun-disappears">
                     <h4>
                         What if the sun disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/fast-charger/fast-charging-technologies-explained">
                     <h4>
                        The principle of fast charging in smartphones
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/flat-earth/the-reality-of-flat-earth-society-debunked">
                     <h4>
                         The reality of flat earth society
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/smartphone-buying/ultimate-guide-to-purchase-smartphone">
                     <h4>
                         Ultimate guide to purchase a new smartphone
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/global-warming/innovative-technology-to-stop-global-warming">
                     <h4>
                        Innovation In Technologies to stop global warming
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/gps-working/indepth-guide-on-how-gps-works">
                     <h4>
                         Indepth guide on the working of GPS
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/pyramids-mystery/aliens-involvement-in-construction-of-pyramids">
                     <h4>
                        The alien involvement in construction of pyramids
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            <div className="other">
                <div className="content1">
                  <Link to="/laptop-buying/ultimate-laptop-buying-guide">
                     <h4>
                         The ultimate laptop buying guide             
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/moon-facts/what-if-moon-disappears">
                     <h4>
                         What if the moon disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 

                
         
</section> 
</Layout>
)}

export default IndexPage
